import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, priceValue } from '../data/content';
import { trackInitiateCheckout } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  label: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
}
export function CtaButton({
  label,
  size = 'md',
  fullWidth = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-[15px] sm:px-9 sm:py-5 sm:text-lg' : 'px-5 py-3.5 text-sm sm:px-7 sm:py-4 sm:text-base';
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout(priceValue)} className={`group inline-flex items-center justify-center gap-2.5 rounded-lg bg-gold text-center font-display font-extrabold uppercase leading-tight tracking-[0.03em] text-navy transition-[transform,background-color] duration-150 ease-smooth hover:-translate-y-0.5 hover:bg-gold-bright focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-bright active:translate-y-0 ${sizing} ${fullWidth ? 'w-full' : ''}`} data-id="element-96" data-mp="lm8ukc2o4oe7">
      {label}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1 sm:h-5 sm:w-5" aria-hidden="true" strokeWidth={2.5} data-id="element-97" data-mp="3a0u47xka5lnq" />
    </a>;
}